/**
 * API path for a Design PDF underlay raster.
 */
export const getBlueprintUnderlayImagePath = (
  projectId: number,
  underlayId: string,
): string => `projects/${projectId}/blueprint-underlays/${underlayId}/image`;
